// AUTO-GENERATED from weborder.json (OpenAPI). Do not edit by hand.
// Domain: files
// Regenerate via scripts/gen-dtos.py

export class FileDetails {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.fileid = raw.fileid ?? "";
    /** @type {number} */
    this.size = raw.size ?? 0;
    /** @type {string} */
    this.name = raw.name ?? "";
    /** @type {string} */
    this.type = raw.type ?? "";
    /** @type {string} */
    this.parentid = raw.parentid ?? "";
    /** @type {string} */
    this.description = raw.description ?? "";
    /** @type {boolean} */
    this.istrace = raw.istrace ?? false;
    /** @type {boolean} */
    this.isallowdelete = raw.isallowdelete ?? false;
    /** @type {FileTaggingMapping[]} */
    this.fileTaggingMappings = Array.isArray(raw.fileTaggingMappings) ? raw.fileTaggingMappings.map((x) => new FileTaggingMapping(x)) : [];
    /** @type {string} */
    this.createdDate = raw.createdDate ?? "";
    /** @type {string} */
    this.lastModifiedDate = raw.lastModifiedDate ?? "";
    /** @type {string} */
    this.userAbbrivation = raw.userAbbrivation ?? "";
  }
}

export class FileDetailsResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.fileid = raw.fileid ?? "";
    /** @type {number} */
    this.size = raw.size ?? 0;
    /** @type {string} */
    this.name = raw.name ?? "";
    /** @type {string} */
    this.type = raw.type ?? "";
    /** @type {number} */
    this.fileDetailsid = raw.fileDetailsid ?? 0;
    /** @type {string} */
    this.createdDate = raw.createdDate ?? "";
    /** @type {string} */
    this.createdBy = raw.createdBy ?? "";
    /** @type {string} */
    this.userAbbrivation = raw.userAbbrivation ?? "";
  }
}

export class FileTaggingMapping {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.masterTag = raw.masterTag ?? "";
    /** @type {string} */
    this.name = raw.name ?? "";
  }
}

/**
 * Rename a required-item file (`PUT /api/weborder/v1/files/{id}/rename`).
 * Path `{id}` is module id; body identifies the file row.
 */
export class UpdateFileRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.fileid = raw.fileid ?? ""; // File record id to rename.
    /** @type {string} */
    this.filename = raw.filename ?? ""; // New display filename.
  }
}

/**
 * Multipart upload for required-item files (`POST
 * /api/weborder/v1/files/upload`). Form field names match property names;
 * **submissionid** required.
 */
export class UploadFileRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string[]} */
    this.file = Array.isArray(raw.file) ? raw.file : []; // One or more files (part name `file`)
    /** @type {number} */
    this.submissionid = raw.submissionid ?? 0; // Required-items module id / submission context id (numeric string).
    /** @type {number} */
    this.itemid = raw.itemid ?? 0; // Required-items module id (numeric).
  }
}

export class UploadFileResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {FileDetails[]} */
    this.fileDetails = Array.isArray(raw.fileDetails) ? raw.fileDetails.map((x) => new FileDetails(x)) : [];
    /** @type {FileDetailsResponse[]} */
    this.submodulefiles = Array.isArray(raw.submodulefiles) ? raw.submodulefiles.map((x) => new FileDetailsResponse(x)) : [];
    /** @type {number} */
    this.fileCount = raw.fileCount ?? 0;
    /** @type {number} */
    this.moduleFileCount = raw.moduleFileCount ?? 0;
  }
}

export class NotesDto {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.id = raw.id ?? 0;
    /** @type {string} */
    this.description = raw.description ?? "";
  }
}
